interface NotificationDropdownProps {
    notifications: any[];
    onClose: () => void;
    handleNotificationClick: (id: number, noti_type:string, leadHashId:string, is_read:string) => void;
    fetchMoreNotifications: () => void,
    hasMore: boolean,
}

const NotificationDropdown = ({ notifications, onClose,handleNotificationClick,fetchMoreNotifications,hasMore }: NotificationDropdownProps) => {
    const handleScroll = (e:any) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop === clientHeight && hasMore) {
            fetchMoreNotifications();
        }
    };

    return (
        <div className="notification-dropdown">
            <div className="notification-container" onScroll={handleScroll}>
                {notifications.length > 0 ? (
                    notifications.map((notification, index) => (
                        <div key={index} className={`notification-item ${+notification.is_read === 0 ? 'unread' : ''}`} onClick={() => handleNotificationClick(notification.id,notification.type,notification.leadHashId,notification.is_read)}>
                            <div className="notification-icon">
                                <img src={notification.image_icon} alt="Icon" />
                            </div>
                            <div className="notification-content">
                                <h4 className="notification-title">{notification.notification_title}</h4>
                                <p className="notification-msg">{notification.notification_msg}</p>
                                <p className="notification-msg">
                                {new Date(notification.created_date).toLocaleString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true,
                                    timeZone: 'Asia/Kolkata'
                                })}
                                </p>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="notification-no-notifications">No notifications available</div>
                )}
            </div>
        </div>
    );
}

export default NotificationDropdown;